import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../public/icons/workflow/close.svg'


const _hoisted_1 = { class: "modal-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-maskV2' : 'modal-mask')
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-containerV2' : 'modal-container')
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-headerV2' : 'modal-header')
                }, [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _cache[2] || (_cache[2] = _createTextVNode(" Information ", -1))
                  ], true),
                  (_ctx.useModalDialogsV2)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_0,
                        class: "theme-svg",
                        id: "close",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                      }))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-bodyV2' : 'modal-body')
                }, [
                  (!_ctx.useModalDialogsV2)
                    ? _renderSlot(_ctx.$slots, "icon", { key: 0 }, () => [
                        _cache[3] || (_cache[3] = _createTextVNode(" default icon ", -1))
                      ], true)
                    : _createCommentVNode("", true),
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _cache[4] || (_cache[4] = _createTextVNode(" default body ", -1))
                  ], true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.useModalDialogsV2 ? 'modal-footerV2' : 'modal-footer')
                }, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _cache[5] || (_cache[5] = _createTextVNode(" default footer ", -1)),
                    _createElementVNode("button", {
                      class: "modal-default-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                    }, " OK ")
                  ], true)
                ], 2)
              ], 2)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}